import { loadStripe } from "@stripe/stripe-js";
import { fetchStripeConfig } from "./api";

const buildTimeKey = process.env.STRIPE_PUBLISHABLE_KEY || "";

let stripePromise;

export async function getStripePromise() {
  if (stripePromise) {
    return stripePromise;
  }

  stripePromise = (async () => {
    let key = buildTimeKey;

    if (!key) {
      try {
        const data = await fetchStripeConfig();
        key = data.publishableKey || "";
      } catch {
        key = "";
      }
    }

    if (!key) {
      return null;
    }

    return loadStripe(key);
  })();

  return stripePromise;
}

export function isStripeConfigured() {
  return Boolean(buildTimeKey);
}
